export default __webpack_public_path__ + "static/media/image-8.25de9d07.png";